import { z } from 'zod';

import {
  CAMPAIGN_ID,
  CitizenTypeEnum,
  createNationalIdSchema,
  createPassportSchema,
} from '@/app/lcv/components/campaigns/big-campaign-2026/actions/schema';
import {
  createFullNameSchema,
  createMobileSchema,
  createPrivacySchema,
} from '@/app/lib/forms/schemas/base-fields.schema';
import { createBaseLocationSchema } from '@/app/lib/forms/schemas/lead-form.schema';
import { BASE_FORM_ERROR_MESSAGE } from '@/app/lib/forms/utils/messages';

const NationalIdFormSchema = z.object({
  type: z.literal('national_id'),
  citizenId: createNationalIdSchema(),
});

const PassportFormSchema = z.object({
  type: z.literal('passport'),
  citizenId: createPassportSchema(),
});

const CitizenIdSchema = z.discriminatedUnion('type', [
  NationalIdFormSchema,
  PassportFormSchema,
]);

export const createBigCampaign2026Schema = () =>
  z
    .object({
      campaign: z.string().min(1).default(CAMPAIGN_ID),
      fullname: createFullNameSchema(),
      phoneNumber: createMobileSchema(),
      ...createBaseLocationSchema().shape,
      privacy: createPrivacySchema(),
      type: CitizenTypeEnum,
      citizenId: z.string(),
      modelCode: z.string().min(1, BASE_FORM_ERROR_MESSAGE.th),
    })
    .superRefine((data, ctx) => {
      const citizenIdResult = CitizenIdSchema.safeParse({
        type: data.type,
        citizenId: data.citizenId,
      });

      if (!citizenIdResult.success) {
        citizenIdResult.error.issues.forEach((error) => {
          ctx.addIssue({
            code: 'custom',
            path: error.path,
            message: error.message,
          });
        });
      }
    });

export const BigCampaign2026Schema = createBigCampaign2026Schema();

export type BigCampaign2026Form = z.infer<typeof BigCampaign2026Schema>;
